export default __webpack_public_path__ + "static/media/pipe-bottom.d354aa87.png";